<template>
  <a-row :gutter="8" :class="getScreen ? 'm-list-wrapper' : 'd-list-wrapper'">
    <a-col :xs="{ span: 24 }" :lg="{ span: 8 }">
      <a-card :loading="loading">
        <div slot="title"><a-icon type="file-search" />&nbsp;Search</div>
        <ul class="m-list-wrapper">
          <li>
            <a-input-search v-model="search" placeholder="Quick Search" />
          </li>
          <li>
            <a-collapse :activeKey="getScreen ? 0 : 1">
              <a-collapse-panel key="1">
                <span slot="header">Search More...</span>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Transaction Date</label>
                  <a-range-picker
                    :placeholder="['Start Date', 'End Date']"
                    v-model="searchDate"
                    :format="getDefaultDateFormat"
                    allowClear
                  />
                </div>
                <div class="m-form-item-wrapper">
                  <label for="kategori">Category</label>
                  <a-select
                    placeholder="Ex: Value's <' 100 Million Rupiah"
                    v-model="kategori"
                    class="width-full"
                    allowClear
                  >
                    <a-select-option value="less">Value's &#60; 100 Million Rupiah</a-select-option>
                    <a-select-option value="over">Value's &#62;= 100 Million Rupiah</a-select-option>
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Status</label>
                  <a-select
                    placeholder="Ex: Approved ... "
                    v-model="status"
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in getStatusWO"
                      :key="item.id"
                      :value="item.value"
                      >{{ item.label }}</a-select-option
                    >
                  </a-select>
                </div>
                <div class="m-form-item-wrapper">
                  <label for="tanggalTransaksi">Supplier</label>
                  <a-select
                    showSearch
                    v-model="supplier_nm"
                    placeholder="Select Supplier Name ..."
                    class="width-full"
                    initialValue="delivered"
                    allowClear
                  >
                    <a-select-option
                      v-for="item in wo_supplier"
                      :key="item"
                      :value="item"
                      >{{ item }}</a-select-option
                    >
                  </a-select>
                </div>
              </a-collapse-panel>
            </a-collapse>
          </li>
        </ul>
      </a-card>
    </a-col>
    <a-col :xs="{ span: 24 }" :lg="{ span: 16 }">
      <DataList
        :loading="loading"
        title="Work Order List"
        createLink="createWO"
        manifestLink="manifestWO"
        editLink="editWO"
        :dataList="searching"
        :estimasi="false"
        :isTransactional="true"
        :allowcancel="true"
      />
    </a-col>
  </a-row>
</template>

<script>
import { mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import CurrencyFormat from "@/mixins/CurrencyFormat";
export default {
  name: "listWO",
  mixins: [CurrencyFormat],
  data() {
    return {
      loading: true,
      dataList: [],
      basedList: [],
      kategori: undefined,
      searchDate: [],
      search: "",
      status: undefined,
      wo_supplier: [],
      supplier_nm: undefined,
    };
  },
  created() {
    this.fetchData();
  },
  activated() {
    this.fetchData();
  },
  mounted() {
    Event.$on("handleCancel", this.canceltrans);
  },
  beforeDestroy() {
    Event.$off("handleCancel", this.canceltrans);
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getStatusWO",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    searching() {
      var self = this;
      let output = this.dataList;

      if (this.search) {
        output = output.filter(
          (obj) =>
            obj.searchQ.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }
      
      if (this.searchDate && this.searchDate.length > 0) {
        let startDt = moment(this.searchDate[0]).format(this.getDefaultDateFormat);
        let endDt = moment(this.searchDate[1]).format(this.getDefaultDateFormat);
        output = output.filter(
          (obj) =>
            obj.tgl_buat &&
            moment(obj.tgl_buat,this.getStandartFormatDate).format(this.getDefaultDateFormat) >= startDt &&
            moment(obj.tgl_buat, this.getStandartFormatDate).format(this.getDefaultDateFormat) <= endDt
        );
      }

      if (this.kategori) {
        output = output.filter((item) => {
          return this.kategori=="less" ? item.estimated_valueRP<100000000 : item.estimated_valueRP>=100000000;
        });
      }

      if (this.status) {
        output = output.filter(
          (obj) =>
            obj.status &&
            obj.status.toLowerCase().indexOf(self.status.toLowerCase()) >= 0
        );
      }

      if (this.supplier_nm) {
        output = output.filter(
          (obj) =>
            obj.supplier &&
            obj.supplier
              .toLowerCase()
              .indexOf(this.supplier_nm.toLowerCase()) >= 0
        );
      }

      return output;
    },
  },
  methods: {
    moment,
    fetchData() {
      axios({
        method: "get",
        url: this.$serviceUrl + "wo",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.basedList = response.data.data;

          response.data.data.forEach((data) => {
            this.dataList.push({
              title: data.no_wo,
              timeline: JSON.parse(data.status_app),
              unread: data.unread == "1" ? true : false,
              subdesc: [
                data.no_pp,
                { deskripsi: data.deskripsi },
                data.supplier,
                this.formatCurrency(data.mata_uang, data.estimated_value),
              ],
              status: data.status,
              id: data.id_wo,
              estimated_value: data.estimated_value,
              estimated_valueRP: data.estimated_valuerp,
              peruntukan: data.peruntukan,
              cancelStatus: data.cancel_sts
                ? data.cancel_sts == 1 
                  ? "Canceled"
                  : (data.cancel_sts == 2 ? "Unusual":null)
                :  null,
              islistPPrevised: data.cancel_sts == 2 ? true:false,
              tgl_buat: data.tgl_buat,
              supplier: data.supplier,
              searchQ:
                data.no_wo +
                " " +
                data.no_pp +
                " " +
                data.tlc_pembuat +
                " " +
                data.estimated_value +
                " " +
                data.mata_uang +
                " " +
                data.deskripsi,
                closed_po_wo: data.close_sts,
            });
          });

          this.dataList.forEach((element) => {
            if (this.wo_supplier.indexOf(element.supplier) === -1) {
              this.wo_supplier.push(element.supplier);
            }
          });

          this.loading = false;
        })
        .catch((err) => {
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
    canceltrans(item) {
      console.log(item);
      axios({
        method: "post",
        url: this.$serviceUrl + "main/cancel_transaction",
        params: {
          tlc: this.getAuth.username,
        },
        data: {
          tlc: this.getAuth.username,
          jenis_trans: "wo",
          id_manifest: item.id,
          code_trans: item.title,
          kode_project: item.kode_project,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          this.displayMessageValue("successCancel", response.data.message);
          this.$router.go();
          this.fetchData();
          this.searching;
        })
        .catch((err) => {
          console.log(err);
          if (!err.response) {
            this.displayMessage("error-connection-refused");
          } else {
            this.loading = false;
            this.displayMessage("empty-db");
          }
        });
    },
  },
};
</script>

<style>
</style>